<template>
  <div class="acceptance-criteria">
    <div class="page-title mb-30">Acceptance Criteria</div>
    <div class="page-content">
      <div class="criteria-card">
        <div class="criteria-card__hdr">
          <span>Acceptance Electrical Criteria</span>
        </div>
        <el-form
          label-width="100px"
          size="mini"
          :model="electricalForm"
          :rules="electricalRules"
          ref="electricalForm"
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="TP3" prop="electricalTP3">
                <el-input v-model="electricalForm.electricalTP3">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- miss -->
            <el-col :xs="24" :sm="6">
              <el-form-item label="TP5" prop="electricalTP5">
                <el-input v-model="electricalForm.electricalTP5">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="TP9" prop="electricalTP9">
                <el-input v-model="electricalForm.electricalTP9">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="TP10" prop="electricalTP10">
                <el-input v-model="electricalForm.electricalTP10">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="TP33" prop="electricalTP33">
                <el-input v-model="electricalForm.electricalTP33">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="TP34" prop="electricalTP34">
                <el-input v-model="electricalForm.electricalTP34">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Volt Error" prop="electricalErrorVoltage">
                <el-input v-model="electricalForm.electricalErrorVoltage">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="Current (avg)" prop="electricalAvgCurrent">
                <el-input v-model="electricalForm.electricalAvgCurrent">
                  <template slot="append"
                    >uA</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Current Error" prop="electricalErrorCurrent">
                <el-input v-model="electricalForm.electricalErrorCurrent">
                  <template slot="append"
                    >uA</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="Packet Size" prop="blePacketSize">
                <el-input v-model="electricalForm.blePacketSize"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Manf. ID" prop="manufacturerId">
                <el-input v-model="electricalForm.manufacturerId"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="RSSI" prop="bleRSSI">
                <el-input v-model="electricalForm.bleRSSI">
                  <template slot="append"
                    >dbm</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="RSSI Error" prop="bleError">
                <el-input v-model="electricalForm.bleError">
                  <template slot="append"
                    >dbm</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Battery" prop="batteryLevel">
                <el-input v-model="electricalForm.batteryLevel">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Battery Error" prop="batteryError">
                <el-input v-model="electricalForm.batteryError">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item
                label="Temperature Error"
                prop="tempError"
                label-width="110px"
              >
                <el-input v-model="electricalForm.tempError">
                  <template slot="append"
                    >C</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="Ar" prop="accAr">
                <el-input v-model="electricalForm.accAr">
                  <template slot="append"
                    >mg</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="ACC R Error" prop="accError">
                <el-input v-model="electricalForm.accError">
                  <template slot="append"
                    >mg</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="RC1_Internal" prop="sensor1Value">
                <el-input v-model="electricalForm.sensor1Value">
                  <template slot="append"
                    >RC</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="RC2_Internal" prop="sensor2Value">
                <el-input v-model="electricalForm.sensor2Value">
                  <template slot="append"
                    >RC</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="RC Error" prop="sensorError">
                <el-input v-model="electricalForm.sensorError">
                  <template slot="append"
                    >RC</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="text-right mt-10 mb-20">
          <el-button
            class="cancel-btn mini-btn min-w-80"
            @click="revert('electricalForm')"
            >REVERT</el-button
          >
          <el-button
            type="primary"
            class="mini-btn min-w-80"
            @click="saveElectricalForm()"
            :loading="loading"
            >SAVE</el-button
          >
        </div>
      </div>
      <div class="criteria-card">
        <div class="criteria-card__hdr">
          <span>Acceptance Functional Criteria</span>
        </div>
        <el-form
          label-width="100px"
          size="mini"
          :model="functionalForm"
          :rules="functionalRules"
          ref="functionalForm"
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="Packet Size" prop="blePacketSize">
                <el-input v-model="functionalForm.blePacketSize"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Manf. ID" prop="manufacturerId">
                <el-input v-model="functionalForm.manufacturerId"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="RSSI" prop="bleRSSI">
                <el-input v-model="functionalForm.bleRSSI">
                  <template slot="append"
                    >dbm</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="RSSI Error" prop="bleError">
                <el-input v-model="functionalForm.bleError">
                  <template slot="append"
                    >dbm</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Battery" prop="batteryLevel">
                <el-input v-model="functionalForm.batteryLevel">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Battery Error" prop="batteryError">
                <el-input v-model="functionalForm.batteryError">
                  <template slot="append"
                    >V</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item
                label="Temperature Error"
                prop="tempError"
                label-width="110px"
              >
                <el-input v-model="functionalForm.tempError">
                  <template slot="append"
                    >C</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="Ax" prop="accAx">
                <el-input v-model="functionalForm.accAx">
                  <template slot="append"
                    >mg</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Ay" prop="accAy">
                <el-input v-model="functionalForm.accAy">
                  <template slot="append"
                    >mg</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Az" prop="accAz">
                <el-input v-model="functionalForm.accAz">
                  <template slot="append"
                    >mg</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Ar" prop="accAr">
                <el-input v-model="functionalForm.accAr">
                  <template slot="append"
                    >mg</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="ACC Error" prop="accError">
                <el-input v-model="functionalForm.accError">
                  <template slot="append"
                    >mg</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="ACC R Error" prop="accRError">
                <el-input v-model="functionalForm.accRError">
                  <template slot="append"
                    >mg</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item label="Small1_Internal" prop="sensor1ValueInt">
                <el-input v-model="functionalForm.sensor1ValueInt">
                  <template slot="append"
                    >pF</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Small2_Internal" prop="sensor2ValueInt">
                <el-input v-model="functionalForm.sensor2ValueInt">
                  <template slot="append"
                    >pF</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Big1_External" prop="sensor1ValueExt">
                <el-input v-model="functionalForm.sensor1ValueExt">
                  <template slot="append"
                    >pF</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item label="Big2_External" prop="sensor2ValueExt">
                <el-input v-model="functionalForm.sensor2ValueExt">
                  <template slot="append"
                    >pF</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6">
              <el-form-item
                label="Middle1_External"
                prop="sensor1ValueChk"
                label-width="95px"
              >
                <el-input v-model="functionalForm.sensor1ValueChk">
                  <template slot="append"
                    >pF</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item
                label="Middle2_External"
                prop="sensor2ValueChk"
                label-width="95px"
              >
                <el-input v-model="functionalForm.sensor2ValueChk">
                  <template slot="append"
                    >pF</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item
                label="Calibration Error"
                prop="sensorError"
                label-width="100px"
              >
                <el-input v-model="functionalForm.sensorError">
                  <template slot="append"
                    >pF</template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="text-right mt-10 mb-20">
          <el-button
            class="cancel-btn mini-btn min-w-80"
            @click="revert('functionalForm')"
            >REVERT</el-button
          >
          <el-button
            type="primary"
            class="mini-btn min-w-80"
            @click="saveFunctionalForm()"
            :loading="loading"
            >SAVE</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      loading: false,
      electricalForm: {
        electricalTP9: '',
        electricalTP5: '',
        electricalTP33: '',
        electricalTP3: '',
        electricalTP10: '',
        electricalTP34: '',
        electricalErrorVoltage: '',
        electricalAvgCurrent: '',
        electricalErrorCurrent: '',
        batteryLevel: '',
        batteryError: '',
        blePacketSize: '',
        bleRSSI: '',
        bleError: '',
        manufacturerId: '',
        tempError: '',
        sensor1Value: '',
        sensor2Value: '',
        sensorError: '',
        accAr: '',
        accError: ''
      },
      eCopy: {},
      electricalRules: {
        electricalTP9: [
          {
            required: true
          }
        ],
        electricalTP5: [
          {
            required: true
          }
        ],
        electricalTP33: [
          {
            required: true
          }
        ],
        electricalTP3: [
          {
            required: true
          }
        ],
        electricalTP10: [
          {
            required: true
          }
        ],
        electricalTP34: [
          {
            required: true
          }
        ],
        electricalErrorVoltage: [
          {
            required: true
          }
        ],
        electricalAvgCurrent: [
          {
            required: true
          }
        ],
        electricalErrorCurrent: [
          {
            required: true
          }
        ],
        batteryLevel: [
          {
            required: true
          }
        ],
        batteryError: [
          {
            required: true
          }
        ],
        blePacketSize: [
          {
            required: true
          }
        ],
        bleRSSI: [
          {
            required: true
          }
        ],
        bleError: [
          {
            required: true
          }
        ],
        manufacturerId: [
          {
            required: true
          }
        ],
        tempError: [
          {
            required: true
          }
        ],
        sensor1Value: [
          {
            required: true
          }
        ],
        sensor2Value: [
          {
            required: true
          }
        ],
        sensorError: [
          {
            required: true
          }
        ],
        accAr: [
          {
            required: true
          }
        ],
        accError: [
          {
            required: true
          }
        ]
      },
      functionalForm: {
        batteryLevel: '',
        batteryError: '',
        blePacketSize: '',
        bleRSSI: '',
        bleError: '',
        manufacturerId: '',
        tempError: '',
        accAx: '',
        accAy: '',
        accAz: '',
        accAr: '',
        accRError: '',
        accError: '',
        sensor1ValueInt: '',
        sensor2ValueInt: '',
        sensorError: '',
        sensor1ValueExt: '',
        sensor2ValueExt: '',
        sensor1ValueChk: '',
        sensor2ValueChk: ''
      },
      fCopy: {},
      functionalRules: {
        batteryLevel: [
          {
            required: true
          }
        ],
        batteryError: [
          {
            required: true
          }
        ],
        blePacketSize: [
          {
            required: true
          }
        ],
        bleRSSI: [
          {
            required: true
          }
        ],
        bleError: [
          {
            required: true
          }
        ],
        manufacturerId: [
          {
            required: true
          }
        ],
        tempError: [
          {
            required: true
          }
        ],
        accAx: [
          {
            required: true
          }
        ],
        accAy: [
          {
            required: true
          }
        ],
        accAz: [
          {
            required: true
          }
        ],
        accError: [
          {
            required: true
          }
        ],
        sensor1ValueInt: [
          {
            required: true
          }
        ],
        sensor2ValueInt: [
          {
            required: true
          }
        ],
        sensorError: [
          {
            required: true
          }
        ],
        sensor1ValueExt: [
          {
            required: true
          }
        ],
        sensor2ValueExt: [
          {
            required: true
          }
        ],
        sensor1ValueChk: [
          {
            required: true
          }
        ],
        sensor2ValueChk: [
          {
            required: true
          }
        ],
        accAr: [
          {
            required: true
          }
        ],
        accRError: [
          {
            required: true
          }
        ]
      }
    }
  },
  mounted: function() {
    this.GetAcceptanceCriteria()
  },
  methods: {
    revert(form) {
      if (form == 'electricalForm') {
        Object.assign(this.electricalForm, this.eCopy)
      } else if (form == 'functionalForm') {
        Object.assign(this.functionalForm, this.fCopy)
      }
      // this.$refs[form].resetFields()
    },
    saveElectricalForm() {
      this.$refs['electricalForm'].validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.SaveElectricalAcceptanceCriteria(this.electricalForm)
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.saved_successfully')
                })
                // this.revert('electricalForm')
                this.eCopy = Object.assign({}, this.electricalForm)
              } else {
                swal({
                  icon: 'error',
                  timer: 2000,
                  title: this.$t('text.failed'),
                  text: response.data.msg
                })
              }
            })
            .catch(() => {
              this.loading = false
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed')
              })
            })
        }
      })
    },
    saveFunctionalForm() {
      this.$refs['functionalForm'].validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.SaveFunctionalAcceptanceCriteria(this.functionalForm)
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.saved_successfully')
                })
                this.fCopy = Object.assign({}, this.functionalForm)
                // this.revert('functionalForm')
              } else {
                swal({
                  icon: 'error',
                  timer: 2000,
                  title: this.$t('text.failed'),
                  text: response.data.msg
                })
              }
            })
            .catch(() => {
              this.loading = false
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed')
              })
            })
        }
      })
    },
    GetAcceptanceCriteria() {
      this.loading = true
      ApiService.GetAcceptanceCriteria()
        .then(response => {
          this.loading = false
          if (response.data.success == 1) {
            if (response.data.data.electricalAcceptanceCriteria != null) {
              this.electricalForm =
                response.data.data.electricalAcceptanceCriteria
            }
            if (response.data.data.functionalAcceptanceCriteria != null) {
              this.functionalForm =
                response.data.data.functionalAcceptanceCriteria
            }
          }
          this.eCopy = Object.assign({}, this.electricalForm)

          this.fCopy = Object.assign({}, this.functionalForm)
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.criteria-card {
  background: #ffffff;
  border: 1px solid #e2e5ec;
  border-radius: 10px;
  margin-bottom: 20px;
  overflow: hidden;

  .el-form {
    padding: 20px 20px 0;
  }

  .text-right {
    padding: 0 20px 20px;
    margin-top: 10px !important;
  }
}
.criteria-card__hdr {
  padding: 13px 16px;
  border-bottom: 1px solid #e2e5ec;
  font-weight: 600;
  font-size: 13px;
  color: #111827;
}
</style>
